import { ClientAPI } from '@/redux/api';

const useSendEmailEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    sendEmail: builder.mutation<boolean, FormData>({
      query: (formData: FormData) => ({
        url: '/form/post',
        method: 'POST',
        body: formData
      })
    })
  })
});

export const { useSendEmailMutation } = useSendEmailEndpoints;

export default useSendEmailEndpoints;
